import { Button, Form, Row, Typography } from "antd"
import { FC } from 'react';
import { makeStyles } from '@mui/styles';
import { QRCodeCanvas } from 'qrcode.react';
import LogoImages from "../../../assets/images/logoSvg.svg";

const useStyles = makeStyles((theme) => ({
  qrcodeContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // height: '100vh',
  },
  downloadButton: {
    cursor: 'pointer',
  },
}));

interface SettingMyQrCodeFormProps {
  id: string
}

const SettingMyQrCodeForm  : FC<SettingMyQrCodeFormProps> = ({
  id
}) => {
  const classes = useStyles();

  const qrcodeData = id 
 
  const logoDataUrl = LogoImages; 
  const downloadQr = () => {
    const qrCanvas = document.getElementById('qr-canvas') as HTMLCanvasElement;
    if (qrCanvas) {
      const qrImageDataUrl = qrCanvas.toDataURL('image/png');

      const link = document.createElement('a');
      link.href = qrImageDataUrl;
      link.download = 'MyQrCode.png';
      link.click();
    }
  };
    
    return (
      <>
        <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 24 }}
        >
            <Row justify={"center"} style={{ marginBottom: 20 }}>
              {qrcodeData ? (
                <div className={classes.qrcodeContainer}>
                  <QRCodeCanvas 
                    size={200} 
                    id="qr-canvas"   
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"L"} 
                    value={qrcodeData}
                    imageSettings={{
                      src: logoDataUrl,
                      height: 30,
                      width: 40,
                      excavate: true,
                    }}
                  />
                </div>
              ) : (
                <div className={classes.qrcodeContainer}>
                  Loading...
                </div>
              )}
            </Row>
            <Row  justify={"center"} style={{ marginBottom: 20 }}>
              <Button onClick={downloadQr} >บันทึกคิวอาร์โค้ด</Button>
             </Row>
        </Form>
    </>
    )
  }

export default SettingMyQrCodeForm

